import React from 'react';
import { useSites } from '../hooks/useSites';
import { useBatiments } from '../hooks/useBatiments';
import { usePieces } from '../hooks/usePieces';

interface LieuxFiltersProps {
  filters: {
    search: string;
    siteId: string;
    batimentId: string;
    pieceId: string;
    theme: string;
  };
  onFilterChange: (name: string, value: string) => void;
  onResetFilters: () => void;
}

const LieuxFilters: React.FC<LieuxFiltersProps> = ({
  filters,
  onFilterChange,
  onResetFilters,
}) => {
  const { data: sites = [] } = useSites();
  const { data: batiments = [] } = useBatiments();
  const { data: pieces = [] } = usePieces();

  // Filtrer les bâtiments et pièces selon la sélection
  const filteredBatiments = filters.siteId
    ? batiments.filter((b: any) => b.siteId === filters.siteId)
    : batiments;

  const filteredPieces = filters.batimentId
    ? pieces.filter((p: any) => p.batimentId === filters.batimentId)
    : pieces;

  // Extraire les thèmes uniques (à améliorer avec données réelles)
  const themes = [
    'Activités nature',
    'Bible & pédagogie spirituelle',
    'Bureautique',
    'Divers & vie quotidienne',
    'Jeux créé / personnalisés',
    'Jeux de société',
    'Jeux extérieurs',
    'Jouets et jeux d\'enfants',
    'Matériel créatif & manuel',
    'Matériel électronique',
    'Matériel vidéo',
    'Musique, son & lumières',
    'Pédagogie',
    'Sécurité & encadrement',
  ];

  return (
    <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-900">Filtres Avancés</h3>
        <button
          onClick={onResetFilters}
          className="text-sm text-blue-600 hover:text-blue-800"
        >
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Filtre Site */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Site
          </label>
          <select
            value={filters.siteId}
            onChange={(e) => onFilterChange('siteId', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Tous les sites</option>
            {sites.map((site: any) => (
              <option key={site.id} value={site.id}>
                {site.nom}
              </option>
            ))}
          </select>
        </div>

        {/* Filtre Bâtiment */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Bâtiment
          </label>
          <select
            value={filters.batimentId}
            onChange={(e) => onFilterChange('batimentId', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={!filters.siteId}
          >
            <option value="">Tous les bâtiments</option>
            {filteredBatiments.map((batiment: any) => (
              <option key={batiment.id} value={batiment.id}>
                {batiment.nom}
              </option>
            ))}
          </select>
        </div>

        {/* Filtre Pièce */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Pièce
          </label>
          <select
            value={filters.pieceId}
            onChange={(e) => onFilterChange('pieceId', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={!filters.batimentId}
          >
            <option value="">Toutes les pièces</option>
            {filteredPieces.map((piece: any) => (
              <option key={piece.id} value={piece.id}>
                {piece.nom}
              </option>
            ))}
          </select>
        </div>

        {/* Filtre Thème */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Thème
          </label>
          <select
            value={filters.theme}
            onChange={(e) => onFilterChange('theme', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Tous les thèmes</option>
            {themes.map((theme) => (
              <option key={theme} value={theme}>
                {theme}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default LieuxFilters;

